import React, { useEffect, useState } from 'react';
import './Admin.scss'
import axios from 'axios';
import MainURL from '../MainURL';
import { FaCheck } from "react-icons/fa";
import { CiWarning } from "react-icons/ci";
import { useNavigate } from 'react-router-dom';
import { useSetRecoilState } from 'recoil';
import { recoilLoginState, recoilUserData } from '../RecoilStore';
import { Icon } from './AdminLayout';

export default function Login () {

  let navigate = useNavigate();
  const setIsLogin = useSetRecoilState(recoilLoginState);
  const setUserData = useSetRecoilState(recoilUserData);
  
  const [refresh, setRefresh] = useState<boolean>(false);
  const [currentTab, setCurrentTab] = useState(1);
  const [userId, setUserId] = useState('');
  const [userPasswd, setUserPasswd] = useState('');

  const [logisterName, setLogisterName] = useState('');
  const [logisterId, setLogisterId] = useState('');
  const [logisterPasswd, setLogisterPasswd] = useState('');
  const [logisterPasswdCheck, setLogisterPasswdCheck] = useState('');

  const handleLogin = async () => {
    await axios
      .post(`${MainURL}/adminlogin/loginadmin`, {
        userId : userId,
        passwd : userPasswd
      })
      .then((res)=>{
        if (res.data.success) {
          if (res.data.auth === 'true') {
            alert('로그인 되었습니다.');
            setIsLogin(true);
            setUserData({
              userId: res.data.userId,
              userName : res.data.name
            })
            setRefresh(!refresh);
            navigate('/admin/main');
          } else {
            alert('관리자 로그인 승인이 필요합니다.');
          }
        } else {
         if (res.data.which === 'id') {
           alert('없는 아이디입니다.');  
         }
         if (res.data.which === 'passwd') {
           alert('비밀번호가 정확하지 않습니다.');
         }
        }
      })
      .catch((err)=>{
        alert('다시 시도해주세요.')
      })
   };
 
  const handleLogister = async () => {
   await axios
    .post(`${MainURL}/adminlogin/logisteradmin`, {
      name : logisterName,
      userId : logisterId,
      passwd : logisterPasswd      
    })
    .then((res)=>{
      if (res.data) {
        alert('가입이 완료되었습니다.');
        setCurrentTab(1);
      }
    })
    .catch((err)=>{
      alert('다시 시도해주세요.')
    })
  };

  return (
    <div className='ad-login'>
      <div className="ad-login__card">

        <div className="ad-login__brand">
          <span className="mark"><Icon name="leaf" /></span>
          <div>
            <h1>새삶공동체 관리자</h1>
            <p>{currentTab === 1 ? '관리자 계정으로 로그인하세요.' : '관리자 계정을 신청합니다. 가입 후 승인이 필요합니다.'}</p>
          </div>
        </div>

        { currentTab === 1 &&
          <div className="ad-card ad-card__pad">
            <div className="ad-field">
              <label htmlFor="adminUserId">아이디</label>
              <input id="adminUserId" value={userId} className="ad-input" type="text" autoComplete="username"
                onChange={(e) => {setUserId(e.target.value)}}
                onKeyDown={(e)=>{if (e.key === 'Enter') {handleLogin();}}}/>
            </div>
            <div className="ad-field">
              <label htmlFor="adminUserPasswd">비밀번호</label>
              <input id="adminUserPasswd" value={userPasswd} className="ad-input" type="password" autoComplete="current-password"
                onChange={(e) => {setUserPasswd(e.target.value)}}
                onKeyDown={(e)=>{if (e.key === 'Enter') {handleLogin();}}}/>
            </div>
            <button type="button" className='ad-btn ad-btn--primary' style={{ marginTop: 6 }} onClick={handleLogin}>
              로그인
            </button>
          </div>
        }

        { currentTab === 2 &&
          <div className="ad-card ad-card__pad">
            <div className="ad-field">
              <label htmlFor="logisterName">이름</label>
              <input id="logisterName" value={logisterName} className="ad-input" type="text"
                onChange={(e) => {setLogisterName(e.target.value)}}/>
            </div>
            <div className="ad-field">
              <label htmlFor="logisterId">아이디</label>
              <input id="logisterId" value={logisterId} className="ad-input" type="text"
                onChange={(e) => {setLogisterId(e.target.value)}}/>
            </div>
            <div className="ad-field">
              <label htmlFor="logisterPasswd">비밀번호</label>
              <input id="logisterPasswd" value={logisterPasswd} className="ad-input" type="password" autoComplete="new-password"
                onChange={(e) => {setLogisterPasswd(e.target.value)}}/>
            </div>
            <div className="ad-field">
              <label htmlFor="logisterPasswdCheck">
                비밀번호 확인
                {
                  (logisterPasswd !== '' && logisterPasswdCheck !== '')
                  &&
                  (
                    logisterPasswd === logisterPasswdCheck
                    ? <span className="ad-login__ok"><FaCheck/> 일치</span>
                    : <span className="ad-login__ng"><CiWarning/> 불일치</span>
                  )
                }
              </label>
              <input id="logisterPasswdCheck" value={logisterPasswdCheck} className="ad-input" type="password" autoComplete="new-password"
                onChange={(e) => {setLogisterPasswdCheck(e.target.value)}}/>
            </div>
            <button type="button" className='ad-btn ad-btn--primary' style={{ marginTop: 6 }}
              onClick={()=>{
                if (logisterId === '' || logisterName === '' || logisterPasswd === '') {
                  alert('빈칸을 채워주세요')
                } else {
                  if (logisterPasswd !== logisterPasswdCheck) {
                    alert('비밀번호가 일치하지 않습니다.')
                  } else {
                    handleLogister();
                  }
                }
              }}
            >
              가입 신청
            </button>
          </div>
        }

        <p className="ad-login__switch">
          {currentTab === 1 ? '계정이 없으신가요?' : '이미 계정이 있으신가요?'}
          <button type="button" onClick={()=>{setCurrentTab(currentTab === 1 ? 2 : 1)}}>
            {currentTab === 1 ? '회원가입' : '로그인'}
          </button>
        </p>
      </div>
    </div>
  );
}

